export type TemplateConfigurationSetupName = 'scheduler' | 'chat';

export type RunningTemplateConfigurationSetupName = TemplateConfigurationSetupName | 'unrecognised';

const SETUPS_THIS_CLIENT_STARTS: Readonly<Record<TemplateConfigurationSetupName, true>> = {
  scheduler: true,
  chat: true,
};

function startedByThisClient(name: string): name is TemplateConfigurationSetupName {
  return name in SETUPS_THIS_CLIENT_STARTS;
}

export function toRunningTemplateConfigurationSetupName(
  wizardName: string | null | undefined,
): RunningTemplateConfigurationSetupName | undefined {
  if (!wizardName) {
    return undefined;
  }
  return startedByThisClient(wizardName) ? wizardName : 'unrecognised';
}

export type TemplateConfigurationSetupStep = 'single-choice' | 'multiple-choice' | 'confirmation';

export interface TemplateConfigurationSetupExistingWidget {
  id: string;
  name: string;
  dataSourceTableId: string;
}

export interface TemplateConfigurationSetupParams {
  widgetId: string;
  pageId: string;
  existingWidgets?: TemplateConfigurationSetupExistingWidget[];
}
